/*
 * @Author: wzh
 * @LastEditTime: 2022-11-24 10:21:47
 * @Description: 配置文件
 */
import { ENVS } from "./envs";
import { SERVICES } from "./services";

export default {
	ENVS,
	SERVICES,
};
